
<template lang="pug">
  .orders-page
    div(v-if="order" tabindex="0")
      h2.title(aria-live="polite") Order {{ order.id }}
      p
        b Purchased on {{ getOrderDate(order) }}
      .two-cols
        div
          .title Shipping Address
          div {{ order.shipping_address.address1 }}
          div( v-if="order.shipping_address.address2" ) {{ order.shipping_address. address2 }}
          div {{ order.shipping_address.city }} {{ order.shipping_address.zip }}
          div {{ order.shipping_address.country_code }}
        div
          .title Billing Address
          div {{ order.billing_address.address1 }}
          div( v-if="order.billing_address.address2" ) {{ order.billing_address. address2 }}
          div {{ order.billing_address.city }} {{ order.billing_address.zip }}
          div {{ order.billing_address.country_code }}
      br
      table
        thead
          tr
            th Product
            th SKU
            th Price
            th Qty
            th Total
        tbody
          tr( v-for="item in order.line_items" )
            td {{ item.name }}
            td {{ item.sku }}
            td ${{ item.price_set.shop_money.amount }}
            td {{ item.quantity }}
            td ${{ item.price }}
        tfoot
          tr( v-if="order.total_discounts && order.total_discounts * 1 > 0" )
            td( colspan="4" ) Discount
            td -${{ order.total_discounts }}
          tr
            td( colspan="4" ) Subtotal
            td ${{ order.current_subtotal_price }}
          tr
            td( colspan="4" ) Shipping
            td ${{ order.total_shipping_price_set.shop_money.amount }}
          tr
            td( colspan="4" ) Total
            td ${{ order.total_price }}

    div(v-else-if="loading" tabindex="0")
      | loading...
    div(aria-live="polite" v-else-if="orders.length === 0" tabindex="0")
      | No orders!
    div(v-else)
      .title Order History
      table
        thead
          tr
            th Order
            th Date
            th Payment Status
            th Fulfillment Status
            th Total
        tbody
          tr(v-for="(order, index) in orders")
            td
              a( href="#" @click.prevent="openOrder(order)" v-text="order.id" )
            td {{ getOrderDate(order) }}
            td {{ (order.financial_status || '').capitalize() }}
            td {{ (order.fulfillment_status || 'Unfulfilled').capitalize() }}
            td {{ order.current_total_price }}
</template>

<script>
  export default {
    name: 'Orders',

    components: {
    },

    props: {
    },

    setup() {
    },

    mounted() {
      this.load();
    },

    data() {
      return {
        loading: true,
        orders: [],
        order: null
      }
    },

    validations () {
      return {
      }
    },

    methods: {
      resetPage() {
        this.order = null;
      },

      load() {
        this.loading = true;
        fetch(
          this.$parent.url + 'orders', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.$parent.getSession())
          }
        ).then(response => response.json()).then(data => {
          if (data.cdata)
            this.$parent.setSession(data);
          this.loading = false;
          this.orders = data || [];
        }).catch(() => {
        });
      },

      getOrderDate(order) {
        const d = new Date(order.created_at);
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getYear() + 1900}`;
      },

      openOrder(order) {
        this.order = order;
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
